import { render, staticRenderFns } from "./PromoItems.vue?vue&type=template&id=2c115daa&"
import script from "./PromoItems.vue?vue&type=script&lang=js&"
export * from "./PromoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VRow,VSelect,VSpacer,VTextField,VToolbar,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686294843/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c115daa')) {
      api.createRecord('2c115daa', component.options)
    } else {
      api.reload('2c115daa', component.options)
    }
    module.hot.accept("./PromoItems.vue?vue&type=template&id=2c115daa&", function () {
      api.rerender('2c115daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PromoItems.vue"
export default component.exports